export default __webpack_public_path__ + "static/media/Quiosque.4b171ae0.png";